<template>
  <div>
    
    <div class="row ">
      
      <div class="col-xl-4 col-sm-6 mb-3" v-for="data in dummyData" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">&nbsp;</div>
            <div class="mr-5">{{ data.message }}</div>
            <div class="mr-5">&nbsp;</div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-3" v-for="data in order(resumeData)" :key="data.order">
        <div :class="'card text-white o-hidden h-100 ' + data.backgroundColor">
          <div class="card-body" >
            <div class="card-body-icon">
              <i :class="data.image"></i>
            </div>
            <div class="mr-5">
              <h5>{{ data.quantity }} {{ $t(data.name) }} actifs</h5>
              </div>
          </div>
         
          <div v-if="data.items != null && data.items.length != 0" v-for="item in data.items" class="card-footer text-white clearfix small z-1" >
            <span class="float-left">{{ item.item1 }}</span>
            <span class="float-right">{{ item.item2 }}</span>
          </div>

          <router-link v-if="data.url != null" :to="data.url" class="card-footer text-white clearfix small z-1">
            <span class="float-left">{{ $t('dashboard.details')}}</span>
            <span class="float-right">
              <i class="fa fa-angle-right"></i>
            </span>
          </router-link>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import {
  MemberServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  ExitServiceClient,
  RoleServiceClient,
  PartnerServiceClient,
  EventServiceClient,
} from '../shared/service-clients/service-clients'

export default {
  name: 'Overview',
  data() {
    return {
      resumeData: [],
      dummyData: [
        {message: 'Loading...'},
        {message: 'Loading...'},
        {message: 'Loading...'},
        {message: 'Loading...'},
        {message: 'Loading...'},
        {message: 'Loading...'},
        {message: 'Loading...'},
      ],
    }
  },
  created: function() {
    this.fetchData()
  },
  methods: {
    getErrorMessage: function(err) {
      this.dummyData.shift()
      this.dummyData.push({message: err.status + ' - ' + err.message})
    },
    order: function(list) {
      return _.orderBy(list, 'order')
    },
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let memberService = ServiceFactory.create(MemberServiceClient)
        let projectService = ServiceFactory.create(ProjectServiceClient)
        let investmentService = ServiceFactory.create(InvestmentServiceClient)
        let exitService = ServiceFactory.create(ExitServiceClient)
        let partnerService = ServiceFactory.create(PartnerServiceClient)
        let eventService = ServiceFactory.create(EventServiceClient)

        self.getMemberData(memberService)
        self.getProspectData(memberService)
        self.getProjecData(projectService)
        self.getInvestmentData(investmentService)
        self.getExitData(exitService)
        self.getPartnerData(partnerService)
        self.getEventData(eventService)
      })
    },
    getEventData: function(service) {
      let self = this
      service
        .getCount()
        .then(res => {
          service.getCountByType().then(res2 => {
            self.resumeData.push({
              order: 7,
              name: 'menu.events',
              backgroundColor: 'bg-primary',
              quantity: res,
              image: 'fa fa-fw fa-calendar',
              items: res2,
              url: '/dashboard/event',
            })
            self.dummyData.pop()
          })
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    getMemberData: function(service) {
      let self = this
      service
        .getCount()
        .then(res => {
          service.getCountByType().then(res2 => {
            self.resumeData.push({
              order: 1,
              name: 'menu.members',
              backgroundColor: 'bg-primary',
              quantity: res,
              image: 'fa fa-fw fa-user-circle-o',
              items: res2,
              url: '/dashboard/member',
            })
            self.dummyData.pop()
          })
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    getProspectData: function(service) {
      let self = this
      service
        .getCountProspect()
        .then(res => {
          self.resumeData.push({
            order: 2,
            name: 'menu.prospects',
            backgroundColor: 'bg-primary',
            quantity: res,
            image: 'fa fa-fw fa-user-circle',
            items: [],
            url: '/dashboard/prospect',
          })
          self.dummyData.pop()
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    getProjecData: function(service) {
      let self = this
      service
        .getCount()
        .then(res => {
          service.getCountByType().then(res2 => {
            self.resumeData.push({
              order: 3,
              name: 'menu.projects',
              backgroundColor: 'bg-primary',
              quantity: res,
              image: 'fa fa-fw fa-building',
              items: res2,
              url: '/dashboard/project',
            })
            self.dummyData.pop()
          })
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    getInvestmentData: function(service) {
      let self = this
      service
        .getCount()
        .then(res => {
          service.getCountByType().then(res2 => {
            self.resumeData.push({
              order: 5,
              name: 'menu.investments',
              backgroundColor: 'bg-success',
              quantity: res,
              image: 'fa fa-fw fa-money',
              items: res2,
              url: '/dashboard/investment',
            })
            self.dummyData.pop()
          })
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    getExitData: function(service) {
      let self = this
      service
        .getCount()
        .then(res => {
          service.getCountByType().then(res2 => {
            self.resumeData.push({
              order: 6,
              name: 'menu.exits',
              backgroundColor: 'bg-danger',
              quantity: res,
              image: 'fa fa-fw fa-sign-out',
              items: res2,
              url: '/dashboard/exit',
            })
            self.dummyData.pop()
          })
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    getPartnerData: function(service) {
      let self = this
      service
        .getCount()
        .then(res => {
          self.resumeData.push({
            order: 4,
            name: 'menu.partners',
            backgroundColor: 'bg-info',
            quantity: res,
            image: 'fa fa-fw fa-handshake-o',
            items: [],
          })
          self.dummyData.pop()
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.card-body-icon {
  font-size: 4.2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue